// src/utils/authStorage.ts
export type VSAuth = {
    accessToken: string;
    refreshToken: string;
    user?: Record<string, any>;
};

const KEY = 'vs_auth';

export function getAuth(): VSAuth | null {
    try {
        const raw = sessionStorage.getItem(KEY);
        if (!raw) return null;
        return JSON.parse(raw) as VSAuth;
    } catch (e) {
        console.warn('getAuth parse failed', e);
        return null;
    }
}

export function setAuth(auth: VSAuth) {
    try {
        sessionStorage.setItem(KEY, JSON.stringify(auth));
    } catch (e) {
        console.warn('setAuth failed', e);
    }
}

export function clearAuth() {
    try {
        sessionStorage.removeItem(KEY);
    } catch (e) {
        /* ignore */
    }
}
